import { addItem, addItems, removeItem, removeItems, setItems, } from '@basket/store/reducers/notices';
export const getNotices = (state) => state.notices.items ?? [];
export const insertNotice = (value) => (dispatch) => Promise.resolve(dispatch(addItem(value)));
export const insertNotices = (value) => (dispatch) => Promise.resolve(dispatch(addItems(value)));
export const overrideNotices = (value) => (dispatch) => Promise.resolve(dispatch(setItems(value)));
export const removeNotice = (value) => (dispatch) => Promise.resolve(dispatch(removeItem(value)));
export const removeNotices = (value) => (dispatch) => Promise.resolve(dispatch(removeItems(value)));
